export default {
  red: '#ef4c4c',
  yellow: '#fd961e',
  green: '#43be39'
}